module.exports = {
	"cs": {
		"conversation": {
			"widget": {
				"title": "",
				"subtitle": ""
			}
		}
	}
};